import raw from './data/country-codes.json'
import type { AllKeysIATA } from './internal/types'

Object.freeze(raw)
const verified: AllKeysIATA<typeof raw> = raw
export const countryCodes: Readonly<Record<keyof typeof raw, string>> = verified

const byAnyString: Readonly<Record<string, string | undefined>> = verified
export function getCountryCode(code: string): string | undefined {
  return byAnyString[code?.toUpperCase()]
}
